import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'overlay'];

  close() {
    this.contentTarget.classList.remove('active');
    this.overlayTarget.classList.remove('overlay--visible');

    document.body.classList.remove('is-scroll-locked');
  }

  open() {
    this.contentTarget.classList.add('active');
    this.overlayTarget.classList.add('overlay--visible');

    document.body.classList.add('is-scroll-locked');
  }

  toggle() {
    this.#active() ? this.close() : this.open();
  }

  #active() {
    return this.contentTarget.classList.contains('active');
  }
}
